import { Component, OnInit } from '@angular/core';
import { DocumentDTO, DownloadResourceService, DocumentationAuthResourceService, DocumentationResourceService } from "@com.sofaxis/sofaxis-fonpel-espace-elus-ws-ts/dist";
import { DownloadHelperService } from "src/app/api/dowload-helper.service";
import { MediaChange, MediaObserver } from '@angular/flex-layout';
import { AdhesionEnLigneResourceService } from 'src/app/api/adhesion-en-ligne-resource.service';



@Component({
  selector: 'app-plan-action',
  templateUrl: './plan-action.component.html',
  styleUrls: ['./plan-action.component.sass']
})
export class PlanActionComponent implements OnInit {

    document: DocumentDTO;

    constructor(private downloadHelperService: DownloadHelperService,
         private adhesionEnLigneResourceService: AdhesionEnLigneResourceService, public media: MediaObserver,
        private downloadService: DownloadResourceService, private documentationService: DocumentationResourceService ) {
    }

    async ngOnInit() {
        this.documentationService.getPlanAction().subscribe( document => {
            this.document = document;
        } );
    }

    download() {
        //this.downloadHelperService.downloadFile( this.document.idDocument, this.document.libelle );
        this.adhesionEnLigneResourceService.downloadDocumentNoAuth(this.document.idDocument).subscribe(
                result => {
                    this.downloadHelperService.saveOrOpenBlob( result, this.document.libelle);
                }
            );
        console.log("download");
    }
}
